const Spinner = () => {
    return (
        <div className="align-items-center justify-content-center">
            <i
                id="document-spinner"
                className="fa fas fa-spinner fa-spin fa-3x"
                aria-hidden="true"></i>
            <span id="document-spinner-text" className="mt-2" aria-hidden="true">
                Loading results...
            </span>
        </div>
    );
}

export default Spinner;